import * as React from "react";

interface LoaderSvgProps {
  bgColor: string;
}

const LoaderSvg = ({ bgColor }: LoaderSvgProps) => {
  return (
    <svg
      className="animate-spin h-5 w-5 self-center"
      style={{ background: bgColor }}
      viewBox="0 0 20 20"
    >
      {`<!-- ... -->`}
    </svg>
  );
};

export default LoaderSvg;
